export const buildNumber = '20260828.3';
export const version = 'main';
export const latestCommit = '02c77e2ccefd33cf021e344b6863db9b463d5794';
